import { useMemo } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import Label from 'LuxKit/Label'

const labelToVariant: Record<string, Partial<React.ComponentProps<typeof Label>['variant']>> = {
  redeemed: 'ghost',
  pending_selection: 'highlight',
  pending_cooldown: 'fast',
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  referralLabel: string
}

function ReferralLabel(props: Props) {
  const { referralLabel, ...rest } = props
  const intl = useIntl()

  const mapLabelToMessage = useMemo(() => ({
    redeemed: intl.formatMessage({
      id: 'XbK4jDearlHD410lpdOU',
      defaultMessage: 'Reward redeemed',
      description: 'Label shown when a referral reward has been redeemed',
    }),
    pending_selection: intl.formatMessage({
      id: 'W_q0TGRJqz9bcWiFezsC',
      defaultMessage: 'Reward available',
      description: 'Label shown when a referral reward is available to claim',
    }),
    pending_cooldown: intl.formatMessage({
      id: 'nv8Cp69M1LdyXd1cpakl',
      defaultMessage: 'First trip booked',
      description: 'Label shown when a referred user has booked their first trip',
    }),
  }), [intl])

  return <Label {...rest} kind="tertiary" variant={labelToVariant[referralLabel]}>
    {mapLabelToMessage[referralLabel as keyof typeof mapLabelToMessage]}
  </Label>
}

export default ReferralLabel
